export const PaperPlaneSkyblue = ({
  height = "48",
  width = "48",
}: {
  height?: string;
  width?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_5424_7030)">
      <rect x="4" y="4" width="40" height="40" rx="20" fill="#EBF5FB" />
      <rect
        x="4.5"
        y="4.5"
        width="39"
        height="39"
        rx="19.5"
        stroke="url(#paint0_linear_5424_7030)"
      />
      <g clipPath="url(#clip0_5424_7030)" filter="url(#filter1_dd_5424_7030)">
        <path
          d="M33.2658 14.7355C32.967 14.4331 32.5953 14.2129 32.1866 14.0961C31.7778 13.9793 31.3459 13.9699 30.9325 14.0688L17.5991 16.8771C16.8313 16.9825 16.1081 17.3 15.511 17.7942C14.9139 18.2883 14.4666 18.9393 14.2194 19.6739C13.9723 20.4085 13.9352 21.1974 14.1123 21.952C14.2893 22.7065 14.6735 23.3967 15.2216 23.9446L16.6533 25.3755C16.7308 25.4529 16.7922 25.5449 16.8341 25.6462C16.876 25.7474 16.8976 25.8559 16.8975 25.9655V28.6055C16.8993 28.9767 16.9848 29.3427 17.1475 29.6763L17.1408 29.6821L17.1625 29.7038C17.4066 30.1948 17.8055 30.5918 18.2975 30.8338L18.3191 30.8555L18.325 30.8488C18.6586 31.0115 19.0246 31.097 19.3958 31.0988H22.0358C22.2567 31.0986 22.4686 31.1862 22.625 31.3421L24.0558 32.773C24.4396 33.161 24.8963 33.4692 25.3998 33.6799C25.9032 33.8906 26.4434 33.9995 26.9891 34.0005C27.4439 33.9999 27.8956 33.9256 28.3266 33.7805C29.0545 33.5415 29.7011 33.1038 30.1935 32.5169C30.6859 31.93 31.0045 31.2171 31.1133 30.4588L33.9258 17.0963C34.0298 16.6793 34.0237 16.2425 33.908 15.8286C33.7923 15.4147 33.571 15.038 33.2658 14.7355ZM17.8333 24.1988L16.4008 22.768C16.0672 22.4424 15.8334 22.0285 15.7269 21.5748C15.6203 21.121 15.6454 20.6463 15.7991 20.2063C15.9482 19.7549 16.2238 19.3558 16.5931 19.0565C16.9625 18.7572 17.41 18.5703 17.8825 18.518L31.0833 15.7388L18.5625 28.2613V25.9655C18.5637 25.6374 18.4999 25.3124 18.3748 25.0091C18.2496 24.7059 18.0656 24.4305 17.8333 24.1988ZM29.4758 30.1738C29.4118 30.6341 29.2208 31.0674 28.9242 31.4252C28.6276 31.7829 28.2372 32.0509 27.7967 32.1991C27.3563 32.3473 26.8833 32.3698 26.4307 32.264C25.9782 32.1583 25.5641 31.9285 25.235 31.6005L23.8016 30.1671C23.5703 29.9345 23.2951 29.7501 22.992 29.6245C22.6889 29.4989 22.3639 29.4347 22.0358 29.4355H19.74L32.2625 16.9171L29.4758 30.1738Z"
          fill="#3498DB"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_5424_7030"
        x="0"
        y="0"
        width="48"
        height="48"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="4"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_5424_7030"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.203922 0 0 0 0 0.596078 0 0 0 0 0.858824 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5424_7030"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5424_7030"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_dd_5424_7030"
        x="8"
        y="12"
        width="32"
        height="32"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="2"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_5424_7030"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5424_7030"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="2"
          operator="erode"
          in="SourceAlpha"
          result="effect2_dropShadow_5424_7030"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_5424_7030"
          result="effect2_dropShadow_5424_7030"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_5424_7030"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_5424_7030"
        x1="24"
        y1="4"
        x2="24"
        y2="44"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AED6F1" />
        <stop offset="1" stopColor="#AED6F1" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip0_5424_7030">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(14 14)"
        />
      </clipPath>
    </defs>
  </svg>
);
